<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Opciones de los módulos
            </h2>
            <small class="title-description">
                Gestion de las opciones de cada módulo
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedOption!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllOptions()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>
<form class="card mt-3" [formGroup]="form">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
            <mat-icon *ngIf="selectedOption&&selectedOption.icono" class="mr-2">
                {{selectedOption&&selectedOption.icono.includes("/")?
                "edit" : selectedOption.icono}}
            </mat-icon>
            <h2 class="m-0 mr-2">
                {{selectedOption&&selectedOption.descripcion_opcion ?
                selectedOption.descripcion_opcion : "Crear"}}
            </h2>
            <small class="title-description">
                {{selectedOption&&selectedOption.funcionalidad_general ?
                selectedOption.funcionalidad_general : "Digite todos los campos"}}
            </small>
        </div>
    </div>
    <div class="card-body">
        <strong>INDICACIONES:</strong>
        <p>Este menú se creó así:</p>
        <ul>
            <li>Modulo 'SUPER ADMINISTRADOR'</li>
            <li>Opción 'ADMINISTRACION' => 'INCLUYE OTRAS OPCIONES = SI'</li>
            <li>Opción 'ENDPOINTS' => 'INCLUYE OTRAS OPCIONES = NO' => 'PADRE = ADMINISTRACION' => 'RUTA =
                super/config/endpoints'</li>
            <li>Opcion 'MENU PRINCIPAL' => 'INCLUYE OTRAS OPCIONES = SI' => 'PADRE = ADMINISTRACION'</li>
            <li>Opción 'ROLES' => 'INCLUYE OTRAS OPCIONES = NO' => 'PADRE = MENU PRINCIPAL' => 'RUTA =
                super/modulos/roles'</li>
        </ul>
        <strong>Posibles errores:</strong>
        <ol>
            <li>Si una opción PADRE no tiene opciones HIJAS con RUTA no se va a mostrar </li>
            <li>Si NO INCLUYE OTRAS OPCIONES, debe asignar una ruta.</li>
            <li>xxxx</li>
            <li>xxxx</li>
        </ol>
        <div class="row">
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Módulo</mat-label>
                <mat-select formControlName="codigo_modulo" (valueChange)="setParentOptions()">
                    <mat-option *ngFor="let module of modules" [value]="module.codigo">
                        {{module.descripcion?.toUpperCase()}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Incluye otras opciones</mat-label>
                <mat-select #isParent (valueChange)="isParent.value==true?setValue('ruta',''):''">
                    <mat-option>Seleccione</mat-option>
                    <mat-option [value]="true">Si</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Opción padre</mat-label>
                <mat-select formControlName="codigo_padre">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let option of parentOptions" [value]="option.codigo">
                        {{option.opcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="descripcion_opcion"
                    (input)="form.get('descripcion_opcion')?.setValue(form.get('descripcion_opcion')?.value.toUpperCase())"
                    type="text" [maxlength]="100">
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Descripción</mat-label>
                <input matInput formControlName="funcionalidad_general"
                    (input)="form.get('funcionalidad_general')?.setValue(form.get('funcionalidad_general')?.value.toUpperCase())"
                    type="text" [maxlength]="200">
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6" *ngIf="!isParent.value">
                <mat-label>Ruta</mat-label>
                <input matInput formControlName="ruta" placeholder="Ignorar /admin/. Solo usar lo que viene después."
                    type="text" [maxlength]="1000" *ngIf="!isParent.value" [required]="isParent.value">
                <!-- <input matInput formControlName="ruta" placeholder="Ignorar si es padre de otras rutas" type="text"
                    [maxlength]="1000" readonly *ngIf="isParent.value"> -->
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="estado">
                    <mat-option [value]="'A'">Activo</mat-option>
                    <mat-option [value]="'I'">Inactivo</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="col-12 col-md-6">
                <mat-label>Ícono</mat-label>
                <mat-select formControlName="icono">
                    <mat-select-trigger class="d-flex align-items-center">
                        <mat-icon class="m-2">{{form.value.icono}}</mat-icon>
                        {{form.value.icono}}
                    </mat-select-trigger>
                    <mat-option *ngFor="let icon of icons" [value]="icon">
                        <mat-icon>{{icon}}</mat-icon>
                        {{icon}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button class="btn btn-secondary" type="button" *ngIf="selectedOption!=undefined"
            (click)="modify()" [ngClass]="{'btn-primary': selectedOption==undefined}">Modificar</button>
        <button mat-flat-button type="button" (click)="create()" class="btn btn-primary">Crear
            nuevo</button>

    </div>
</form>
<div class="shadow mt-3">
    <coky-table [title]="'Listado de opciones'" [description]="'Seleccione un registro para modificar'" [data]="options"
        (clickRow)="showMenuOptions($event)" [multipleSelection]="false" [columns]="optionColumns">
    </coky-table>
</div>